<script>
    import APIS from '@/util/apis';
    import {mapState} from 'vuex';
    import {getPlatform} from '@/frontend-lib/tools/getPlatform';
export default {
    render(h) {
        var topbarConfig = this.topbarConfig;
        var platform = this.platform;
        var getRoute = this.getRoute;
        var isBaiduminiapp = getPlatform().isBaiduminiapp
        var homeBtn;
        console.log(this.$router)
        if(isBaiduminiapp && topbarConfig.home === 'msite'){
            homeBtn = null;
        }else{
            if (topbarConfig.home === 'msite') {
                homeBtn = <a onClick={this.goHome} class="d-ibm icon-wrap" ><i class="d-b icon-home"></i></a>;
            } else if (topbarConfig.home === 'cp') {
                homeBtn = <router-link class="d-ibm icon-wrap" to={getRoute({name: 'home'})}><i class="d-b icon-home"></i></router-link>
            } else {
                homeBtn = null;
            }
        }
        return <div class="topbar" style={{borderColor: topbarConfig.borderColor}}>
            <div class="s-tabcell topbar-left fl">
                { topbarConfig.back ? <span class="d-ibm icon-wrap" onClick={this.back}><i class="d-b icon-back"></i></span> : null}
                {homeBtn}
            </div>
            <div class="fs-16 topbar-title s-tabcell"><span class="d-ibm">{topbarConfig.title || ''}</span></div>
            {topbarConfig.handlers ? (<div class="topbar-handlers fs-15 s-tabcell fr">
                {topbarConfig.handlers.map(function(item, i) {
                    if (item.component) {
                        return <component is={item.component}></component>
                    } else {
                        var icon = item.icon ? <div class={(item.text ? 'd-ibm' : 'd-b') + ' icon-wrap'}><i class={'d-b icon-' + item.icon}></i></div> : null;
                        var text = item.text ? <span class={(item.icon ? 'd-ibm' : 'd-b') + ' topbar-handlers__text'}>{item.text}</span> : null;

                        if (item.route) {
                            return <router-link class="d-ibm" to={getRoute(item.route)} key={i}>
                                {icon}
                                {text}
                            </router-link>
                        } else if (item.href) {
                          return <a class="d-ibm" key={i} href={item.href}>
                            {icon}
                            {text}
                          </a>
                        } else {
                            return <div class="d-ibm" key={i}>
                                {icon}
                                {text}
                            </div>
                        }
                    }
                })}
            </div>) : null}
        </div>
    },

    computed: {
        ...mapState({
            topbarConfig: 'topbarConfig'
        })
    },
    mounted() {
        this.back = this.back.bind(this);
    },
    methods: {
        back() {
            if (this.$route.name === 'answer') {
                window.Stream.dialog('<div><p class="fs-18 text-bold">是否退出答题</p><p>退出当前答题页后，将不保留你当前的答题情况</p></div>', '确定退出', '取消', {reverse: true}).addListener({
                    next(res){
                        if(res.value === 'success') {
                                history.back()
                        }
                    }
                });
                // let goout = confirm('您确定要退出答题吗？');
                // if(goout) {
                //     history.back()
                // }
            } else {
                if(history.length > 1) {
                    history.back()
                } else {
                    if (this.platform.isPc) {
                        location.href = `//www${APIS.env}.xinli001.com/ceshi`;
                        return
                    }
                    location.href = `//m${APIS.env}.xinlii01.com`;
                }
            }
        },
        getRoute(route) {
            let r;
            if (typeof (route) === 'string') {
                r = {name: route}
            } else {
                r = route;
            }
            console.log(r);
            return Object.assign(r, {query: Object.assign(this.userInfo, {channelId: this.contextData.channelId})})
        },
        goHome() {
            console.log('跳转首页')
            const urlIsCeShi = location.pathname.split('/')[1] === 'ceshi'
            if (this.platform.isPc) {
                location.href = `//www${APIS.env}.xinli001.com/ceshi`;
                return
            }else if(this.platform.isWechat && urlIsCeShi){
                location.href = `//cp-wx.xinli001.cc/ceshi`;
                return
            }
            location.href = `//m${APIS.env}.xinli001.com`
        }
    }
}
</script>

<style lang="scss" src="../scss/topbar.scss"></style>



// WEBPACK FOOTER //
// src/components/top-bar.vue